import * as actions from "../actions";
import _ from "lodash";
import numeral from "numeral";

/*eslint default-case: 0*/

const defaultState = () => ({
    occmDemo: {status: actions.STATUS_NOT_SENT},
    refreshToken: {status: actions.STATUS_NOT_SENT},
    integrationInstructionsOpenRow: "Introduction",
    americasGlobalSpiffStatus: "PENDING",
    americasGlobalSpiffData: {},
    itemForDeletion: null,
    deleteSalesItemError: null,
    deleteSalesItemPending: null,
    itemForUpdate: null,
    saveSalesContentAction: null,
    saveItemContentPending: false,
    saveItemContentError: null,
    salesItems: [],
    salesItemsFetchPending: true,
    salesItemsFetchError: null
});

const sortSalesItems = salesItems => _.orderBy(salesItems, ['serviceName', 'topic', 'updateTime'], ['asc', 'asc', 'desc']);

export default (state = defaultState(), {payload, type, status}) => {
    switch(type){
        case "INTERNAL:OCCM-DEMO": {
            switch (status){
                case actions.STATUS_SUCCESS:
                    return { ...state, occmDemo: {status: actions.STATUS_SUCCESS, data: payload.data}};
                case actions.STATUS_ERROR:
                    return { ...state, occmDemo: {status: actions.STATUS_ERROR}};
                case actions.STATUS_PENDING:
                    return { ...state, occmDemo: {status: actions.STATUS_PENDING}};
            }
            break;
        }
        case "OCCM-DEMO-RESET": {
            return { ...state, occmDemo: {status: actions.STATUS_NOT_SENT }};
        }
        case "GET-REFRESH-TOKEN": {
            switch (status) {
                case actions.STATUS_SUCCESS:
                    return {...state, refreshToken: {status: actions.STATUS_SUCCESS, data: payload.data}};
                case actions.STATUS_ERROR:
                    return {...state, refreshToken: {status: actions.STATUS_ERROR, data: payload.data}};
                case actions.STATUS_PENDING:
                    return { ...state, refreshToken: {status: actions.STATUS_PENDING}};
            }
            break;
        }
        case "INTERNAL:INTEGRATION-INSTRUCTIONS-TOGGLE-ROW": {
            let newRow = null;
            if(state.integrationInstructionsOpenRow !== payload){
                newRow = payload;
            }
            return {...state, integrationInstructionsOpenRow: newRow}
        }
        case "INTERNAL:FETCH-AMERICAS-GLOBAL-SPIFF-DATA-PENDING": {
            return {...state, americasGlobalSpiffStatus: "PENDING", americasGlobalSpiffData: {} }
        }
        case "INTERNAL:FETCH-AMERICAS-GLOBAL-SPIFF-DATA-SUCCESS": {
            const teamChallenge = payload.teamChallenge;
            const individualChallengeRules = payload.individualChallengeRules;
            const individualChallengeRunners = payload.individualChallengeRunners;
            const partnerReport = payload.partnersReport;

            const areaMapper = {
                "Enterprise": "enterprise",
                "Commercial/Canada": "commercial",
                "USPS": "usps",
                "Canada/LATAM": "canada-latam",
                "Globals": "globals"
            };

            individualChallengeRules.forEach(rule => {
                rule.area = areaMapper[rule.Area] || areaMapper["Globals"];
                rule.category = rule.Geo === "Globals" ? `${rule.Area}-${rule.Title}` : rule.Title;
                rule.target = rule["Target Licenses"];
                rule.vouchers = rule["Available Vouchers"];
            });

            const rulesByAreas = _.groupBy(individualChallengeRules, "area");

            const titleMapper = {
                "GEM": "GEM/Account Owner",
                "TAM": "TAM/SE"
            };

            individualChallengeRunners.forEach(winner => {
                winner.area = areaMapper[winner.Area] || areaMapper["Globals"];
                winner.role = winner.Geo === "Globals" ? titleMapper[winner.Title] : winner.Title;
                winner.name = winner.Name;
                winner.licenses = Number(winner.Licenses);
                // winner.index = winner["Winner Index"] && parseInt(winner["Winner Index"]);
                winner.category = winner.Geo === "Globals" ? `${winner.Area}-${winner.role}` : winner.role;
                winner.eligible = winner["Eligible"] === 1;
                winner.customers = winner["Customers"];
                winner.minimumNumberOfLicenses = winner["Minimum Licenses"];
                winner.minimumNumberOfCustomers = winner["Minimum Customers"];
            });

            const runnersByAreas = _.groupBy(individualChallengeRunners, "area");

            teamChallenge.forEach((district) => {
                district.fValue = numeral(district.Revenue).format('$0,0');
                district.name = district["District/Region"];
                district.value = parseFloat(district.Revenue);
                district.passesThreshold = Number(district["Licenses"]) >= Number(district["Minimum Licenses"]) && Number(district["Customers"]) >= Number(district["Minimum Customers"]);
                district.area = areaMapper[district["Geo/Area"]];
                district.numberOfCustomers = district["Customers"];
                district.numberOfLicenses = district["Licenses"];
                district.minimumNumberOfLicenses = district["Minimum Licenses"];
                district.minimumNumberOfCustomers = district["Minimum Customers"];
                district.vouchers = district["Vouchers"];
            });

            const teamChallengeByDistricts = _(teamChallenge).sortBy("value").groupBy("area").value();

            _.forEach(teamChallengeByDistricts, area => {
                _.forEach(_.reverse(area), (district, place) => {
                    district.place = place + 1;
                })
            });

            const globalsTeamChallenge = _(teamChallengeByDistricts.globals)
                .map((district) => ({ licenses: Number(district["Licenses"]), winnerIndex: Number(district["Winner Index"]) ,...district }))
                .sortBy("licenses")
                .reverse()
                .value();
            _.forEach(globalsTeamChallenge, (district, place) => {
                district.place = place + 1;
            });

            const globalsTeamData = {districts: globalsTeamChallenge, totalLicenses: _.sumBy(globalsTeamChallenge, "licenses")};

            console.log(JSON.stringify(globalsTeamData));

            partnerReport.forEach((partner) => {
                partner.fValue = numeral(partner["booking_amount"]).format('$0,0');
                partner.value = parseFloat(partner["booking_amount"]);
            });

            const partnersReportByBookings = _(partnerReport)
                .sortBy("value")
                .reverse()
                .value();

            return {...state, americasGlobalSpiffStatus: "SUCCESS", americasGlobalSpiffData: { accounts: payload.accounts , teamChallenge: teamChallengeByDistricts, rules: rulesByAreas, runners: runnersByAreas, partners: partnersReportByBookings, globals: globalsTeamData}};
        }
        case "INTERNAL:FETCH-AMERICAS-GLOBAL-SPIFF-DATA-ERROR": {
            return {...state, americasGlobalSpiffStatus: "ERROR", americasGlobalSpiffError: _.get(payload, "response.data.message", "Failed to save fetch spiff data.")}
        }
        case "INTERNAL:OPEN-DIALOG-AMERICAS-GLOBALS": {
            const districts = state.americasGlobalSpiffData.teamChallenge[payload.area];
            return {...state, americasGlobalSpiffDistrictDialog: payload.districtName, americasGlobalSpiffSelectedDistrict: _.find(districts, {name: payload.districtName})}
        }
        case "INTERNAL:CLOSE-DIALOG-AMERICAS-GLOBALS": {
            return {...state, americasGlobalSpiffDistrictDialog: null}
        }
        case "INTERNAL:GLOBAL-FILE-CACHE-LICENSE-REQUEST-FORM-CLEAR-SUCCESS-MESSAGE": {
            const existingId = state.licenseRequestFormSuccessMessageId;
            if(payload !== existingId) {
                return {...state}
            } else {
                return {...state, licenseRequestFormSuccessMessage: null}
            }
        }
        case "INTERNAL:GLOBAL-FILE-CACHE-LICENSE-REQUEST-FORM-PENDING": {
            return {...state, isLicenseRequestFormSaving: true, licenseRequestFormSuccessMessage: null, licenseRequestFormSaveError: null}
        }
        case "INTERNAL:GLOBAL-FILE-CACHE-LICENSE-REQUEST-FORM-SUCCESS": {
            return {...state, isLicenseRequestFormSaving: false, licenseRequestFormSuccessMessage: "Form successfully sent.", licenseRequestFormSuccessMessageId: payload}
        }
        case "INTERNAL:GLOBAL-FILE-CACHE-LICENSE-REQUEST-FORM-ERROR": {
            return {...state, isLicenseRequestFormSaving: false, licenseRequestFormSaveError: _.get(payload, "response.data.message", "Failed to send form email.")}
        }
        case "INTERNAL:OPEN-MODAL-SALES-CONTENT": {
            const { saveSalesContentAction, itemForUpdate } = payload;
            return { ...state, saveSalesContentAction, itemForUpdate };
        }
        case "INTERNAL:CLOSE-MODAL-SALES-CONTENT": {
            return { ...state, saveSalesContentAction: null, itemForUpdate: null, saveItemContentPending: false, saveItemContentError: null };
        }
        case "INTERNAL:SAVE-SALES-ITEM-CONTENT": {
            const { itemForUpdate } = payload;
            return { ...state, itemForUpdate, saveItemContentPending: true };
        }
        case "INTERNAL:SAVE-SALES-ITEM-CONTENT-SUCCESS": {
            const { newSalesItem } = payload;
            const saveSalesContentAction = state.saveSalesContentAction;
            const salesItems = state.salesItems;
            let sortedItems;
            if (saveSalesContentAction === "update") {
                sortedItems = _.map(salesItems, item => item.id === newSalesItem.id ? newSalesItem : item);
            } else {
                sortedItems = sortSalesItems([...salesItems, newSalesItem]);
            }
            return { ...state, saveSalesContentAction: null, modalSalesItemState: null, salesItems: sortedItems, saveItemContentPending: false, saveItemContentError: null };
        }
        case "INTERNAL:SAVE-SALES-ITEM-CONTENT-FAILURE": {
            const { saveItemContentError } = payload;
            return { ...state, modalSalesItemState: null, saveItemContentError, saveItemContentPending: false };
        }
        case "INTERNAL:OPEN-MODAL-DELETE-SALES-ITEM": {
            const { itemForDeletion } = payload;
            return {...state, itemForDeletion }
        }
        case "INTERNAL:CLOSE-MODAL-DELETE-SALES-ITEM": {
            return { ...state, itemForDeletion: null }
        }
        case "INTERNAL:DELETE-SALES-ITEM": {
            return { ...state, deleteSalesItemError: null, deleteSalesItemPending: true };
        }
        case "INTERNAL:DELETE-SALES-ITEM-SUCCESS": {
            const { itemForDeletion, salesItems } = state;
            const newSalesItems = _.reject(salesItems, item => item.id === itemForDeletion.id);
            return { ...state, deleteSalesItemError: null, deleteSalesItemPending: false, salesItems: newSalesItems, itemForDeletion: null };
        }
        case "INTERNAL:DELETE-SALES-ITEM-FAILURE": {
            const { deleteSalesItemError } = payload;
            return { ...state, deleteSalesItemError, deleteSalesItemPending: false };
        }
        case "INTERNAL:FETCH-SALES-ITEMS": {
            return {...state, salesItemsFetchPending: true }
        }
        case "INTERNAL:FETCH-SALES-ITEMS-SUCCESS": {
            const { salesItems } = payload;
            const sortedItems = sortSalesItems(salesItems);
            return {...state, salesItems: sortedItems, salesItemsFetchPending: false }
        }
        case "INTERNAL:FETCH-SALES-ITEMS-FAILURE": {
            const { salesItemsFetchError } = payload;
            return {...state, salesItemsFetchError, salesItemsFetchPending: false }
        }
    }
    return state;
};
